/* eslint-disable max-lines */
import gql from 'graphql-tag';

export const COMMON_APP_QUERY = {
  es: gql`
    query Common {
      common {
        socialNetworks {
          facebook
          instagram
        }
        cookieLaw {
          buttonText: buttonText_es
          content: content_es
          show
        }
        logoLight {
          url
        }
        logoDark {
          url
        }
        enabledLanguage
        enabledChat
        lightNavbar
        whiteNavbar
        footer {
          shape {
            type
            color
          }
          logo {
            url
          }
          content: content_es
        }
      }
    }
  `,
  en: gql`
    query Common {
      common {
        socialNetworks {
          facebook
          instagram
        }
        cookieLaw {
          buttonText: buttonText_en
          content: content_en
          show
        }
        logoLight {
          url
        }
        logoDark {
          url
        }
        enabledLanguage
        enabledChat
        lightNavbar
        whiteNavbar
        footer {
          shape {
            type
            color
          }
          logo {
            url
          }
          content: content_en
        }
      }
    }
  `
};

export const HOME_PAGE_QUERY = {
  es: gql`
    query Home {
      home {
        enabledBgCarouselOverlay
        intervalCarousel
        alert {
          badgeText: badgeText_es
          content: content_es
          badgeClass
          alertClass
        }
        mainSlider {
          type: __typename
          ... on ComponentCarouselCarouselBgOverlay {
            titleFirst: titleFirst_es
            titleSecond: titleSecond_es
            typerItems: typerItems_es
            content: content_es
            buttons {
              text: text_es
              class
              iconClass
              href
              scrollTo
              target
              internal
              showIconOnTheLeft
            }
            images {
              url
              mime
            }
          }
          ... on ComponentCarouselCarouselClassic {
            carouselClassicItem {
              title: title_es
              content: content_es
              image {
                url
                mime
              }
              buttons {
                text: text_es
                class
                iconClass
                href
                scrollTo
                target
                internal
                showIconOnTheLeft
              }
            }
          }
        }
        whatWeDoSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
        projectsSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
          homeProjectSectionCarouselProps {
            autoplay
            autoplayTimeout
            autoplayHoverPause
            scrollPerPage
            loop
            paginationEnabled
          }
        }
        reviewsSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
        }
        getInTouchSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
      }
    }
  `,
  en: gql`
    query Home {
      home {
        enabledBgCarouselOverlay
        intervalCarousel
        alert {
          badgeText: badgeText_en
          content: content_en
          badgeClass
          alertClass
        }
        mainSlider {
          type: __typename
          ... on ComponentCarouselCarouselBgOverlay {
            titleFirst: titleFirst_en
            titleSecond: titleSecond_en
            typerItems: typerItems_en
            content: content_en
            buttons {
              text: text_en
              class
              iconClass
              href
              scrollTo
              target
              internal
              showIconOnTheLeft
            }
            images {
              url
              mime
            }
          }
          ... on ComponentCarouselCarouselClassic {
            carouselClassicItem {
              title: title_en
              content: content_en
              image {
                url
                mime
              }
              buttons {
                text: text_en
                class
                iconClass
                href
                scrollTo
                target
                internal
                showIconOnTheLeft
              }
            }
          }
        }
        whatWeDoSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
        projectsSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
          homeProjectSectionCarouselProps {
            autoplay
            autoplayTimeout
            autoplayHoverPause
            scrollPerPage
            loop
            paginationEnabled
          }
        }
        reviewsSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
        }
        getInTouchSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
      }
    }
  `
};

export const PROJECTS_PAGE_QUERY = {
  es: gql`
    query Project {
      project {
        pageHeader {
          title: title_es
          content: content_es
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        projectsListSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
        }
      }
    }
  `,
  en: gql`
    query Project {
      project {
        pageHeader {
          title: title_en
          content: content_en
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        projectsListSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
        }
      }
    }
  `
};

export const OUR_COMPANY_PAGE_QUERY = {
  es: gql`
    query Company {
      company {
        pageHeader {
          title: title_es
          content: content_es
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        aboutUsSection {
          number
          symbol
          countText: countText_es
          content: content_es
          typeImgCol
          media {
            url
            alternativeText
            mime
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
          }
        }
        teamSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            type
            buttons: buttons_es
            warning: warning_es
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
        reviewsSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            type
            buttons: buttons_es
            warning: warning_es
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
      }
    }
  `,
  en: gql`
    query Company {
      company {
        pageHeader {
          title: title_en
          content: content_en
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        aboutUsSection {
          number
          symbol
          countText: countText_en
          content: content_en
          typeImgCol
          media {
            url
            alternativeText
            mime
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
          }
        }
        teamSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            type
            buttons: buttons_en
            warning: warning_en
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
        reviewsSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            type
            buttons: buttons_en
            warning: warning_en
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
      }
    }
  `
};

export const WHAT_WE_DO_PAGE_QUERY = {
  es: gql`
    query WhatWeDo {
      whatWeDo {
        pageHeader {
          title: title_es
          content: content_es
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        description: description_es
        servicesSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
        workProcessSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_es
            content: content_es
            buttons: buttons_es
            warning: warning_es
            type
          }
          buttons {
            text: text_es
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
          workProcessItem {
            title: title_es
            description: description_es
            icon
          }
        }
      }
    }
  `,
  en: gql`
    query WhatWeDo {
      whatWeDo {
        pageHeader {
          title: title_en
          content: content_en
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        description: description_en
        servicesSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
        }
        workProcessSection {
          bgColor {
            color
          }
          shape {
            color
            type
          }
          header {
            title: title_en
            content: content_en
            buttons: buttons_en
            warning: warning_en
            type
          }
          buttons {
            text: text_en
            class
            iconClass
            href
            scrollTo
            target
            internal
            showIconOnTheLeft
          }
          workProcessItem {
            title: title_en
            description: description_en
            icon
          }
        }
      }
    }
  `
};

export const CONTACT_PAGE_QUERY = {
  es: gql`
    query Contact {
      contact {
        pageHeader {
          title: title_es
          content: content_es
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        items {
          type
          title: title_es
          content: content_es
          value
          icon {
            url
          }
        }
        content {
          mapEmbedUrl
          enabledMap
          enabledContactForm
          imageContact {
            url
          }
          formSuccessMessage: formSuccessMessage_es
          formErrorMessage: formErrorMessage_es
        }
      }
    }
  `,
  en: gql`
    query Contact {
      contact {
        pageHeader {
          title: title_en
          content: content_en
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        items {
          type
          title: title_en
          content: content_en
          value
          icon {
            url
          }
        }
        content {
          mapEmbedUrl
          enabledMap
          enabledContactForm
          imageContact {
            url
          }
          formSuccessMessage: formSuccessMessage_en
          formErrorMessage: formErrorMessage_en
        }
      }
    }
  `
};

export const LEGAL_QUERY = {
  es: gql`
    query Legal {
      legal {
        pageHeader {
          title: title_es
          content: content_es
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        advertisement {
          content: content_es
        }
        privacy {
          content: content_es
        }
        cookies {
          content: content_es
        }
      }
    }
  `,
  en: gql`
    query Legal {
      legal {
        pageHeader {
          title: title_en
          content: content_en
          bgOverlay
          bgImage {
            url
          }
          shape {
            type
            color
          }
        }
        advertisement {
          content: content_en
        }
        privacy {
          content: content_en
        }
        cookies {
          content: content_en
        }
      }
    }
  `
};
